// extracted by mini-css-extract-plugin
export default {"roundMediaPlusContent":"RoundedMediaPlusContent_roundMediaPlusContent__Do3it","img":"RoundedMediaPlusContent_img__pSE81","imgHolder":"RoundedMediaPlusContent_imgHolder__sXNut"};